import {useEffect, useRef, useState} from "react";
import {Box, IconButton, Paper} from "@mui/material";
import {STYLES} from "./styles";
import SearchInputUI from "./SearchInputUI";
import SearchButtonUI, {SearchButtonLabelViewModelType} from "./SearchButtonUI";
import SearchButtonDropdownMain, {
  SearchButtonDropdownType,
} from "./search-button-dropdown/search-button-dropdown-main";
import SearchIconProblemsetSvg from "../../assets/icons/custom/search_icon_problemset";
import FilterSwitch from "../filter-switch";
interface SearchUIProps {
  searchData: {
    buttonLabelViewModel: SearchButtonLabelViewModelType | undefined;
    dropdownType: SearchButtonDropdownType;
    hasAnimation?: boolean;
  };
  placeholder?: string;
}
export default function SearchUI({searchData, placeholder}: SearchUIProps) {
  const searchButtonRef = useRef<HTMLButtonElement>(null);
  const [isButtonDropdownOpen, setIsButtonDropdownOpen] = useState(false);

  const onSearchButtonClick = () => {
    if (searchData.hasAnimation) {
      searchButtonRef.current?.scrollIntoView({behavior: "smooth"});
      searchButtonRef.current?.addEventListener("animationend", () => {
        setIsButtonDropdownOpen(true);
      });
    } else {
      setIsButtonDropdownOpen(true);
    }
  };

  return (
    <>
      <Paper id="search-ui-paper" component="form" sx={STYLES.searchPaper}>
        <Box ref={searchButtonRef} sx={{scrollMarginTop: "10px"}}>
          <SearchButtonUI
            onClick={onSearchButtonClick}
            labelViewModel={searchData.buttonLabelViewModel}
          />
        </Box>
        <SearchButtonDropdownMain
          anchorRef={searchButtonRef}
          openState={[isButtonDropdownOpen, setIsButtonDropdownOpen]}
          dropdownType={searchData.dropdownType}
        />

        {/** SEARCH */}
        <Box
          id="search-input-box"
          width={"100%"}
          display={"flex"}
          alignItems={"center"}
          ml={"12px"}>
          <SearchInputUI placeholder={placeholder} />
          <IconButton
            type="button"
            sx={STYLES.searchIconButton}
            aria-label="search">
            <SearchIconProblemsetSvg sx={STYLES.searchSvgIcon} />
          </IconButton>
        </Box>
      </Paper>
      <FilterSwitch />
    </>
  );
}
